import { makeStyles } from '@material-ui/styles';
import useUserStore from '@services/stores/UserStore';
import { useTranslation } from '@tools/i18n';
import { useState } from 'react';
import CallToActionButton from '@components/products/partials/CallToActionButton';
import theme from '@components/theme';

const useStyles = makeStyles({
    label: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        background: '#00000010',
        padding: 10,
    },
    alert: {
        display: 'grid',
        gridTemplateColumns: '1fr 160px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
        background: '#00000008',
        // @ts-ignore
        [theme.breakpoints?.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: '15px'
        }
    },
}, { name: 'account-email-verified' });

export const AccountEmailVerified = () => {
    const user = useUserStore();
    const myNewportService = useUserStore((state) => state.getService());
    const classes = useStyles();
    const { t } = useTranslation([ 'account' ]);
    const [ loadingVerifyDone, setLoadingVerifyDone ] = useState(false);
    const [ loadingVerify, setLoadingVerify ] = useState(false);

    function renderVerifyEmail() {
        if (user?.user?.email_verified_at) {
            return null;
        }

        if (user?.user?.needs_email) {
            return null;
        }

        return <div className={classes.alert}>
            {t('account:please-verify-email', { email: user?.user?.email })}
            <CallToActionButton
                isDone={loadingVerifyDone}
                size={'small'}
                isLoading={loadingVerify}
                onClick={async (e) => {
                    setLoadingVerify(true);
                    const response = await myNewportService.sendVerificationEmail()
                        .finally(() => setLoadingVerify(false));

                    if (response.status === 'success') {
                        setLoadingVerifyDone(true);
                    }
                }}
            >
                {t('account:re-send-button')}
            </CallToActionButton>
        </div>;
    }

    return renderVerifyEmail();
}
